import { render, staticRenderFns } from "./DraggableGuest.vue?vue&type=template&id=5cb1e566&"
import script from "./DraggableGuest.vue?vue&type=script&lang=js&"
export * from "./DraggableGuest.vue?vue&type=script&lang=js&"
import style0 from "./DraggableGuest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DraggableGuest.vue"
export default component.exports